import { useCallback } from 'react';
import { fetchTopicData } from '../services/api';

const useSuggestionHandler = (
  // user,
  // openSignInModal,
  setTopic,
  setIsLoading,
  setError,
  setShowSearchSuggestions,
  setIsSearchTriggered,
  setTopicData,
  setSessionId,
  createNodesFromData,
  createEdgesFromData,
  sessionId,
  setNodes,
  setEdges
) => {
  const handleSuggestionClick = useCallback(
    async (suggestion) => {
      try {
        // Continue with handling the suggestion
        setTopic(suggestion);
        setIsLoading(true); // Set loading immediately
        setError(null);
        setShowSearchSuggestions(false);
        setIsSearchTriggered(true);

        try {
          const data = await fetchTopicData(suggestion, sessionId);
          if (data && Array.isArray(data.result)) {
            setTopicData(data.result);
            setSessionId((prevSessionId) => prevSessionId || data.session_id);

            const newNodes = createNodesFromData(data.result);
            const newEdges = createEdgesFromData(data.result);
            setNodes(newNodes);
            setEdges(newEdges);
          } else {
            console.error("No data returned from Search Suggestion API call");
            setError("No data found");
          }
        } catch (err) {
          setError(err.response?.data?.detail || "Error fetching data");
          console.error("Error:", err);
        } finally {
          setIsLoading(false);
        }
      } catch (authError) {
        console.error("Error during sign-in:", authError);
      }
    },
    [
      // user,
      // openSignInModal,
      setTopic,
      setIsLoading,
      setError,
      setShowSearchSuggestions,
      setIsSearchTriggered,
      setTopicData,
      setSessionId,
      createNodesFromData,
      createEdgesFromData,
      sessionId,
      setNodes,
      setEdges
    ]
  );

  return { handleSuggestionClick };
};

export default useSuggestionHandler;